import { jsx } from "react/jsx-runtime";
import { CollectionsPanel } from "./components/collections-panel.js";
import { CollectionsSessionActions } from "./components/session-actions.js";
import SvgCollections from "./icons/collections.js";
/* empty css          */
import { collectionsStore, useCollectionsStore } from "./store.js";
import { createLocalStorageAdapter, localStorageAdapter } from "./storage/local-storage.js";
import { SaveDialog } from "./components/save-dialog.js";
const collectionsPlugin = (options) => {
  function CollectionsPanelWithOptions() {
    return /* @__PURE__ */ jsx(
      CollectionsPanel,
      {
        readOnly: options == null ? void 0 : options.readOnly,
        allowImportExport: options == null ? void 0 : options.allowImportExport,
        allowReplace: options == null ? void 0 : options.allowReplace
      }
    );
  }
  function CollectionsSessionActionsWithOptions() {
    return /* @__PURE__ */ jsx(
      CollectionsSessionActions,
      {
        storage: options == null ? void 0 : options.storage,
        readOnly: options == null ? void 0 : options.readOnly,
        allowImportExport: options == null ? void 0 : options.allowImportExport,
        allowReplace: options == null ? void 0 : options.allowReplace
      }
    );
  }
  return {
    title: "Collections",
    icon: SvgCollections,
    content: CollectionsPanelWithOptions,
    sessionActions: CollectionsSessionActionsWithOptions
  };
};
export {
  SaveDialog as CollectionsSaveDialog,
  collectionsPlugin,
  collectionsStore,
  createLocalStorageAdapter,
  localStorageAdapter,
  useCollectionsStore
};
//# sourceMappingURL=index.js.map
